export enum Relationship {
  GUARDIAN = 'GUARDIAN',
  FRIEND = 'FRIEND',
  SISTER = 'SISTER',
  BROTHER = 'BROTHER',
  AUNT = 'AUNT',
  UNCLE = 'UNCLE',
  COUSIN = 'COUSIN',
  GRANDPARENT = 'GRANDPARENT',
  NON_DEPENDANT = 'NON_DEPENDANT',
  OTHER = 'OTHER',
}
export interface IAdditionalPassport {
  docNumber: string;
  placeOfIssue: string;
  issuingAuthority: string;
  issueDate: string;
  expiryDate: string;
}

export interface IOtherUkVisas {
  visaType: string;
  country: string;
  issuingAuthority: string;
  issueDate: string;
  expiryDate: string;
}

export interface ITripToUk {
  arrivalDate: string;
  departureDate: string;
  purpose: string;
}
export interface IExclusionOrder {
  exclusionDate: string;
  reason: string;
  reference: string;
}

export interface ILeaveToRemain {
  applicationDate: string;
  applicationType: string;
  reference: string;
}

export interface IBorderRefusal {
  refusalDate: string;
  airport: string;
  reason: string;
  reference: string;
}

export interface IDeportation {
  country: string;
  removalDate: string;
  airport: string;
  reason: string;
}

export interface ITravelItems {
  country: string;
  reason: string;
  reasonOther: string;
  entryDate: string;
  exitDate: string;
}

export enum MaritalStatus {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  UNMARRIED = 'UNMARRIED',
  DIVORCED = 'DIVORCED',
  SEPARATED = 'SEPARATED',
  WIDOWED = 'WIDOWED',
}

export interface IChildDetails {
  nationality: string;
  familyName: string;
  givenName: string;
  dob: string;
  gender: string;
  sameNationality?: boolean;
  ukVisa?: boolean;
  hasPassport?: boolean;
  passportNumber: string;
  placeOfBirth: string;
  travellingWith: string;
}

export interface IOtherTravellers {
  nationality: string;
  familyName: string;
  givenName: string;
  dob: string;
  sameNationality?: boolean;
  ukVisa?: boolean;
  hasPassport?: boolean;
  passportNumber: string;
  relationship?: Relationship;
  relationshipOther: string;
  adultOrChild: string;
}

export interface IFamilyMember {
  nationality: string;
  familyName: string;
  givenName: string;
  dob: string;
}

export interface IVisaPrepForm {
  hasBeenActivated: boolean;

  hasAdditionalPassports?: boolean;
  additionalPassports?: Array<IAdditionalPassport>;

  residentialAddressStartDate?: string;
  homeOwnershipStatus?: string;
  homeOwnershipStatusOther?: string;
  hasDifferentContactDetails?: boolean;
  diffContactAddress?: string;
  diffContactCity?: string;
  diffContactPostcode?: string;
  diffContactCountry?: string;

  nonHomeCountryApplicationDesc?: string;
  hasOtherUkVisas?: boolean;
  otherUkVisas?: Array<IOtherUkVisas>;
  tripsToUk?: Array<ITripToUk>;
  hasBeenToUk?: boolean;
  hasNINumber?: boolean;
  niNumber?: string;
  hasReceivedMedicalTreatment?: boolean;
  hasVoluntarilyDeparted?: boolean;
  hasExclusionOrder?: boolean;
  exclusionOrders?: Array<IExclusionOrder>;
  leaveToRemains?: Array<ILeaveToRemain>;
  borderRefusals?: Array<IBorderRefusal>;
  hasBeenDeported?: boolean;
  deportations?: Array<IDeportation>;
  hasTravelled?: boolean;
  travelItems?: Array<ITravelItems>;
  maritalStatus?: MaritalStatus;
  spouseNationality?: string;
  spouseSameNationality?: boolean;
  spouseFamilyName?: string;
  spouseGivenName?: string;
  spouseDob?: string;
  spouseLivingWith?: boolean;
  spouseTravellingWith?: string;
  spouseUkVisa?: boolean;
  spouseHasPassport?: boolean;
  spousePassportNumber?: string;
  hasFathersPersonalDetails?: boolean;
  fatherNationality?: string;
  fatherSameNationality?: boolean;
  fatherFamilyName?: string;
  fatherGivenName?: string;
  fatherDob?: string;
  fatherPlaceOfBirth?: string;
  fatherTravellingWith?: string;
  fatherUkVisa?: boolean;
  fatherHasPassport?: boolean;
  fatherPassportNumber?: string;
  hasMothersPersonalDetails?: boolean;
  motherNationality?: string;
  motherSameNationality?: boolean;
  motherFamilyName?: string;
  motherGivenName?: string;
  motherDob?: string;
  motherPlaceOfBirth?: string;
  motherTravellingWith?: string;
  motherUkVisa?: boolean;
  motherHasPassport?: boolean;
  motherPassportNumber?: string;
  hasGuardiansPersonalDetails?: boolean;
  guardianNationality?: string;
  guardianSameNationality?: boolean;
  guardianFamilyName?: string;
  guardianGivenName?: string;
  guardianDob?: string;
  guardianPlaceOfBirth?: string;
  guardianTravellingWith?: string;
  guardianUkVisa?: boolean;
  guardianHasPassport?: boolean;
  guardianPassportNumber?: string;
  hasDependantChildren?: boolean;
  children?: Array<IChildDetails>;
  childrenLivingWithYou?: boolean;
  contactAddress?: string;
  contactCity?: string;
  contactPostcode?: string;
  contactCountry?: string;
  contactNumber?: string;
  travellingWithOthers?: boolean;
  otherTravellers?: Array<IOtherTravellers>;
  hasArrivalDate?: boolean;
  arrivalDate?: string;
  lengthOfStayDays?: number;
  lengthOfStayMonths?: number;
  lengthOfStayYears?: number;
  ukPresence?: boolean;
  ukFamily?: boolean;
  stayingWithFamily?: boolean;
  familyMembers?: Array<IFamilyMember>;
  familyContactAddress?: string;
  familyContactCity?: string;
  familyContactPostcode?: string;
  familyContactCountry?: string;
  familyPhoneNumber?: string;
  familyEmail?: string;
  hasOtherContactAddress?: boolean;
  otherContactAddress?: string;
  otherContactCity?: string;
  otherContactPostcode?: string;
  otherContactCountry?: string;
  otherPhoneNumber?: string;
  hasCriminalCharges?: boolean;
  hasTerrorismInvolvement?: boolean;
  hasTerrorismConnection?: boolean;
  hasTerrorismJustified?: boolean;
  hasWarCrimes?: boolean;
  hasBadActivities?: boolean;
  language?: string;
  hasReceivedCas?: boolean;
  studiesConfirmationNumber?: string;
  courseEndDate?: string;
  alreadyStartedStudying?: boolean;
  studyAddress?: string;
  assessedBySponsor?: boolean;
  qualificationAsProofOfEnglish?: boolean;
  qualificationAndCountry?: string;
  appliedThroughUCAS?: boolean;
  ucasPin?: string;
  otherFeedback?: string;
  difficultiesFeedback?: string;

  isSectionStarted?: boolean;
  isSectionComplete?: boolean;
  isPage1Complete?: boolean;
  isPage1_2Complete?: boolean;
  isPage2_1Complete?: boolean;
  isPage2_2Complete?: boolean;
  isPage2_3Complete?: boolean;
  isPage2_4Complete?: boolean;
  isPage2_5Complete?: boolean;
  isPage2_6Complete?: boolean;
  isPage2_7Complete?: boolean;
  isPage2_8Complete?: boolean;
  isPage3_1Complete?: boolean;
  isPage3_2Complete?: boolean;
  isPage3_3Complete?: boolean;
  isPage3_4Complete?: boolean;
  isPage3_5Complete?: boolean;
  isPage4Complete?: boolean;
  isPage5Complete?: boolean;
  isPage6Complete?: boolean;
  isPage7_1Complete?: boolean;
  isPage7_2Complete?: boolean;
  isPage7_3Complete?: boolean;
  isPage8Complete?: boolean;
}

export enum ShareCodeStatus {
  NONE = 'NONE',
  VERIFIED = 'VERIFIED',
  NOT_VERIFIED = 'NOT_VERIFIED',
  EXPIRING_SOON = 'EXPIRING_SOON',
  EXPIRED = 'EXPIRED',
}
